import * as React from 'react';

const MoneyGraphicSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g
            id="money-graphic_svg__MoneyGraphic_2"
            stroke="none"
            strokeWidth={1}
            fill="none"
            fillRule="evenodd"
        >
            <g id="money-graphic_svg__Group-29" transform="translate(24 34)">
                <path
                    id="money-graphic_svg__Fill-1"
                    fill="#FFF"
                    d="M13.5 74.51h81V35.765h-81z"
                />
                <path
                    d="M12 76h84.001V34.274H12V76zm3-2.981h77.999V37.255H15v35.764z"
                    id="money-graphic_svg__Fill-2"
                    fill="#1E0A3C"
                />
                <path
                    id="money-graphic_svg__Fill-3"
                    fill="#FFF"
                    d="M7.5 68.549h81V29.804h-81z"
                />
                <path
                    d="M6 70.039h84V28.314H6v41.725zm3-2.98h78V31.294H9v35.765z"
                    id="money-graphic_svg__Fill-4"
                    fill="#1E0A3C"
                />
                <path
                    id="money-graphic_svg__Fill-5"
                    fill="#DBDAE3"
                    d="M1.5 62.588h81V23.843h-81z"
                />
                <path
                    d="M0 64.078h84V22.353H0v41.725zm3-2.98h78V25.334H3v35.764z"
                    id="money-graphic_svg__Fill-6"
                    fill="#1E0A3C"
                />
                <path
                    id="money-graphic_svg__Fill-7"
                    fill="#F05537"
                    d="M72 58.117H12l-6-5.962v-17.88l6-5.96h60l6 5.96v17.882z"
                />
                <g id="money-graphic_svg__Group-28">
                    <path
                        d="M52.5 43.216c0 5.76-4.701 10.432-10.5 10.432s-10.5-4.671-10.5-10.432S36.201 32.784 42 32.784s10.5 4.67 10.5 10.432"
                        id="money-graphic_svg__Fill-8"
                        fill="#FFF"
                    />
                    <path
                        d="M42 55.138c-6.617 0-12-5.35-12-11.922 0-6.573 5.383-11.922 12-11.922 6.616 0 12 5.349 12 11.922s-5.384 11.922-12 11.922m0-20.863c-4.963 0-9 4.009-9 8.94 0 4.932 4.037 8.943 9 8.943s9-4.011 9-8.942c0-4.932-4.037-8.941-9-8.941"
                        id="money-graphic_svg__Fill-10"
                        fill="#1E0A3C"
                    />
                    <path
                        id="money-graphic_svg__Fill-12"
                        fill="#1E0A3C"
                        d="M19.5 44.706h3v-2.98h-3z"
                    />
                    <path
                        id="money-graphic_svg__Fill-14"
                        fill="#1E0A3C"
                        d="M13.5 44.706h3v-2.98h-3z"
                    />
                    <path
                        id="money-graphic_svg__Fill-16"
                        fill="#1E0A3C"
                        d="M67.5 44.706h3v-2.98h-3z"
                    />
                    <path
                        id="money-graphic_svg__Fill-18"
                        fill="#1E0A3C"
                        d="M61.5 44.706h3v-2.98h-3z"
                    />
                    <path
                        id="money-graphic_svg__Fill-20"
                        fill="#1E0A3C"
                        d="M34.5 19.99l-7.061-7.015 2.122-2.107 4.939 4.908 4.939-4.908 2.122 2.107z"
                    />
                    <path
                        id="money-graphic_svg__Fill-22"
                        fill="#1E0A3C"
                        d="M61.5 19.99l-7.061-7.015 2.122-2.107 4.939 4.908 4.939-4.908 2.122 2.107z"
                    />
                    <path
                        id="money-graphic_svg__Fill-24"
                        fill="#1E0A3C"
                        d="M36 17.882h-3V2.98H0V0h36z"
                    />
                    <path
                        id="money-graphic_svg__Fill-26"
                        fill="#1E0A3C"
                        d="M63 17.882h-3V0h36v2.98H63z"
                    />
                </g>
            </g>
        </g>
    </svg>
);

MoneyGraphicSvg.displayName = 'MoneyGraphicSvg';
export default MoneyGraphicSvg;
